import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

interface SimpleSliderProps {
  children: React.ReactNode[];
  showNavigation?: boolean; // default: true
  onReady?: (swiper: SwiperType) => void;
}

const SimpleSlider: React.FC<SimpleSliderProps> = ({
  children,
  showNavigation = true,
  onReady,
}) => {
  const prevRef = useRef<HTMLButtonElement | null>(null);
  const nextRef = useRef<HTMLButtonElement | null>(null);
  const swiperRef = useRef<SwiperType | null>(null);

  return (
    <div className="simple-slider relative">
      <Swiper
        modules={[Navigation, Pagination]}
        slidesPerView={1}
        spaceBetween={16}
        navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
        pagination={{ clickable: true }}
        onSwiper={(swiper: SwiperType) => {
          swiperRef.current = swiper;
          if (onReady) onReady(swiper);
        }}
      >
        {children.map((child, index) => (
          <SwiperSlide key={`slide-${index}`} className="preview-slide">
            {child}
          </SwiperSlide>
        ))}
      </Swiper>

      {showNavigation && (
        <div className="slider-nav flex-row absolute">
          <button ref={prevRef} className="nav-btn prev" aria-label="Previous">
            ◀
          </button>
          <button ref={nextRef} className="nav-btn next" aria-label="Next">
            ▶
          </button>
        </div>
      )}
    </div>
  );
};

export default SimpleSlider;
